var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZhCn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18696_44107",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18696_44107)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V24H0V0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0155 4.54813L14.0053 5.15797L14.2357 3.96794L13.3945 3.07732L14.5336 3.02916L15.0155 1.91797L15.4974 3.02916H16.6345L15.7953 3.96794L16.0479 5.15797L15.0155 4.54813Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01729 9.60703L4.13646 11.158L4.79356 8.13147L2.39453 5.86644L5.64295 5.74397L7.01729 2.91797L8.39164 5.74397H11.6345L9.24103 8.13147L9.96161 11.158L7.01729 9.60703Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0155 8.54813L16.0053 9.15797L16.2357 7.96794L15.3945 7.07732L16.5336 7.02916L17.0155 5.91797L17.4974 7.02916H18.6345L17.7953 7.96794L18.0479 9.15797L17.0155 8.54813Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0155 12.5481L15.0053 13.158L15.2357 11.9679L14.3945 11.0773L15.5336 11.0292L16.0155 9.91797L16.4974 11.0292H17.6345L16.7953 11.9679L17.0479 13.158L16.0155 12.5481Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0155 15.5481L12.0053 16.158L12.2357 14.9679L11.3945 14.0773L12.5336 14.0292L13.0155 12.918L13.4974 14.0292H14.6345L13.7953 14.9679L14.0479 16.158L13.0155 15.5481Z",
    fill: "#FECA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhCn);
export default __webpack_public_path__ + "static/media/zh-CN.5711850b26f1fd066fdefb8c42ae205f.svg";
export { ForwardRef as ReactComponent };